import * as React from "react";
import Menu from "@mui/material/Menu";
import { Avatar, ListItemIcon } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { useAuthStore } from "hooks/useAuthStore";
import { FaUserCircle } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useAmnistiaStore } from "hooks/useAmnistiaStore";
import { useDemandaStore } from "hooks/useDemandaStore";
import { useExpediente } from "hooks/useExpediente";
import { useHomeStore } from "hooks/useHomeStore";
import { useJuzgadosConExpediente } from "hooks/juzgadoConExpediente/useJuzgadosConExpediente";
import { useLibroIndice } from "hooks/useLibroIndice";
import { usePromocionStore } from "hooks/usePromocionStore";
import { useReportesStore } from "hooks/useReportesStore";
import { useGeneralStore } from "hooks/generalesStore";
import { useVisorDocumentosStore } from "hooks/useVisorDocumentosStore";

export const SettingsUser = () => {
  const { urlPhoto, user, startLogout } = useAuthStore();
  const {resetAmnistia} = useAmnistiaStore();
  const {allResetStateDemandas} = useDemandaStore();
  const {resetStatePortadas} = useExpediente()
  const {resetStateHome} = useHomeStore();
  const {resetStateJuzgadoExp} = useJuzgadosConExpediente();
  const {resetLibroIndice} = useLibroIndice();
  const {allresetPromocionesState} = usePromocionStore();
  const {resetAll} = useReportesStore()
  const {resetFormCarpetas} = useGeneralStore()
  const {resetAllState} = useVisorDocumentosStore()

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const closeSession = () => {
    startLogout();
    resetAmnistia();
    allResetStateDemandas();
    resetStatePortadas();
    resetStateHome();
    resetStateJuzgadoExp();
    resetLibroIndice();
    allresetPromocionesState();
    resetAll();
    resetFormCarpetas();
    resetAllState();
  };
  const name = user.fullName?.substring(0);

  return (
    <>
      <Avatar
        alt={name}
        src={urlPhoto}
        sx={{ width: 35, height: 35 }}
        onClick={handleMenu}
      />

      <Menu
        sx={{ mt: "45px" }}
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem>
          <Link to="/dashboard/mi-perfil">
            <ListItemIcon>
              <FaUserCircle />
            </ListItemIcon>
            Mi Perfil
          </Link>
        </MenuItem>
        <MenuItem onClick={closeSession}>
          <ListItemIcon>
            <FiLogOut />
          </ListItemIcon>
          Cerrar Sesión
        </MenuItem>
      </Menu>
    </>
  );
};
